export const PromoCodeQSIdentifier = 'pc';
export const PromoCodeLocalStorageIdentifier = 'landings_pc';
